/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApiKey } from 'model/apiKeys';
import { Action } from 'redux';

export const API_KEYS_ERROR = 'apiKeys/error';
interface ApiKeysErrorAction extends Action<typeof API_KEYS_ERROR> {
    payload: {
        error: string;
    };
}

export const API_KEYS_CLEAR_ERROR = 'apiKeys/clear_error';
type ApiKeysClearErrorAction = Action<typeof API_KEYS_CLEAR_ERROR>;

export const API_KEYS_CLEAR_SUCCESS = 'apiKeys/clear_success';
type ApiKeysClearSuccessAction = Action<typeof API_KEYS_CLEAR_SUCCESS>;

export const API_KEYS_RESET = 'apiKeys/reset';
type ApiKeysResetAction = Action<typeof API_KEYS_RESET>;

export const API_KEYS_FETCH_START = 'apiKeys/fetch_start';
type ApiKeysFetchStartAction = Action<typeof API_KEYS_FETCH_START>;

export const API_KEYS_FETCH_SUCCESS = 'apiKeys/fetch_success';
interface ApiKeysFetchSuccessAction extends Action<typeof API_KEYS_FETCH_SUCCESS> {
    payload: {
        apiKeys: Array<ApiKey>;
    };
}

export const API_KEYS_SAVE_START = 'apiKeys/save_start';
type ApiKeysSaveStartAction = Action<typeof API_KEYS_SAVE_START>;

/**
 * Note: the payload carries the API Key WITHOUT its secret. The secret from a
 * create or rotate response is returned to the caller by the thunk and never
 * dispatched, so it stays out of the store and out of DevTools.
 */
export const API_KEYS_SAVE_SUCCESS = 'apiKeys/save_success';
interface ApiKeysSaveSuccessAction extends Action<typeof API_KEYS_SAVE_SUCCESS> {
    payload: {
        apiKey: ApiKey;
    };
}

export const API_KEYS_ROTATE_START = 'apiKeys/rotate_start';
type ApiKeysRotateStartAction = Action<typeof API_KEYS_ROTATE_START>;

export const API_KEYS_ROTATE_SUCCESS = 'apiKeys/rotate_success';
interface ApiKeysRotateSuccessAction extends Action<typeof API_KEYS_ROTATE_SUCCESS> {
    payload: {
        apiKey: ApiKey;
    };
}

export const API_KEYS_REVOKE_START = 'apiKeys/revoke_start';
type ApiKeysRevokeStartAction = Action<typeof API_KEYS_REVOKE_START>;

/**
 * Revocation is logical: the backend sets `active: false` and keeps the row.
 * The reducer marks it inactive rather than removing it from the list.
 */
export const API_KEYS_REVOKE_SUCCESS = 'apiKeys/revoke_success';
interface ApiKeysRevokeSuccessAction extends Action<typeof API_KEYS_REVOKE_SUCCESS> {
    payload: {
        apiKeyId: number;
    };
}

export type ApiKeysAction =
    | ApiKeysErrorAction
    | ApiKeysClearErrorAction
    | ApiKeysClearSuccessAction
    | ApiKeysResetAction
    | ApiKeysFetchStartAction
    | ApiKeysFetchSuccessAction
    | ApiKeysSaveStartAction
    | ApiKeysSaveSuccessAction
    | ApiKeysRotateStartAction
    | ApiKeysRotateSuccessAction
    | ApiKeysRevokeStartAction
    | ApiKeysRevokeSuccessAction;
